import { api } from "./client.js";
import type { Application, ApplicationTemplate, ApplicationAnswers } from "@wwrp/shared";

export type ApplicationDetail = Application & {
  staffNotes?: { id: number; body: string; createdAt: string }[];
  actions: Record<string, boolean>;
};
export const applicationsApi = {
  templates: () => api.get<ApplicationTemplate[]>("/applications/templates"),
  list: () => api.get<Application[]>("/applications"),
  detail: (id: number) => api.get<ApplicationDetail>(`/applications/${id}`),
  submit: (templateId: number, answers: ApplicationAnswers) =>
    api.post<{ id: number }>("/applications", { templateId, answers }),
  decision: (
    id: number,
    body: { side: string; round: number; decision: string; note?: string; stipulations?: string },
  ) => api.post(`/applications/${id}/reviews`, body),
  message: (id: number, body: string) => api.post(`/applications/${id}/messages`, { body }),
  privateNote: (id: number, body: string) => api.post(`/applications/${id}/notes`, { body }),
  revision: (id: number, body: string) =>
    api.post(`/applications/${id}/revision-request`, { body }),
  resubmit: (id: number, answers: ApplicationAnswers) =>
    api.post(`/applications/${id}/resubmit`, { answers }),
  withdraw: (id: number) => api.post(`/applications/${id}/withdraw`),
  createTemplate: (body: unknown) => api.post<{ id: number }>("/applications/templates", body),
  updateTemplate: (id: number, body: unknown) => api.patch(`/applications/templates/${id}`, body),
};
